export function MentionedComments() {
  // Placeholder
  return null
}
